import { createI18n } from 'vue-i18n'
import zh from './locales/zh'
import zhTW from './locales/zh-TW'

const i18n = createI18n({
  legacy: false,
  locale: localStorage.getItem('language') || 'zh-TW',
  fallbackLocale: 'zh-TW',
  messages: {
    zh,
    'zh-TW': zhTW
  }
})

export default i18n
